/* PagingAuditSummaryFeed.js */

"use strict";
const PagingFeed = require("../../../../lib/PagingFeed");
const _ = require("lodash");

class PagingAuditSummaryFeed extends PagingFeed {
    _getFeed() {
        return this._EntityDef.startRelatedAuditSummariesFeed(this._filter, this._entityFields, this._sort, { skip: 0, limit: this._pageSize * 2 });
    }

    _feedShutDown() {
        if (_.isUndefined(this._EntityDef)) {
            return Promise.resolve();
        } else {
            return this._EntityDef.stopRelatedAuditSummariesFeed();
        }
    }
}

module.exports = PagingAuditSummaryFeed;
